// external js: flickity.pkgd.js

// Add this code:

$(window).on("resize", function() {
	if ($(this).width() > 1025) {
		if (window.device == 'mobile') {
			location.reload()
		}
		window.device = 'desktop';
	} else {
		if (window.device == 'desktop') {
			location.reload()
		}
		window.device = 'mobile';
	}
}).trigger("resize")




var _scrollLast = 0
var _windowH = $(window).height()

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()

	if (_scrollTop < _windowH * 0.1) {
		return false;
	}

	if (_scrollTop > _scrollLast) {
		$("#topmenuWrap").addClass("is-hide")
	} else {
		$("#topmenuWrap").removeClass("is-hide")
	}

	_scrollLast = _scrollTop
})



function ryderenter() {
	$("[data-r]").each(function(i, el) {

		if (device == 'mobile' && $(el).data("mobile-r") != undefined) {
			var _p = $(el).data("mobile-r")
		} else {
			var _p = $(el).data("r")
		}

		var _st_default = {
			trigger: el,
			start: "top 80%",
			end: "bottom 0%",
			toggleActions: "play none play none",
			// toggleActions: "play reverse play reverse",
			// markers: true,
		}

		var _st = Object.assign(_st_default, _p.scrollTrigger)

		var _t = $(el).offset().top
		var _hook = $(window).height() * _st.start.replace(/[^0-9]/g, '') / 100

		if (_t <= _hook) {
			_p.delay = (_p.delay != undefined) ? _p.delay += 1.5 : 1.5
		}

		delete _p.scrollTrigger

		var _setting = {
			scrollTrigger: _st,
			duration: 2,
			opacity: 0,
			ease: "power2.out",
		}

		if (_p != '' && "stagger" in _p) {
			var $el = $(el).children()
		} else {
			var $el = el
		}

		var _obj = Object.assign(_setting, _p);

		gsap.from($el, _obj);
	})
}


function draw() {
	$(".draw path").each(function(i, el) {
		gsap.timeline({
			paused: true,
			scrollTrigger: {
				trigger: el,
				toggleActions: "play none play none",
				start: "center 90%",
				end: "bottom 20%",
				// markers: true,
			},
		}).from(el, {
			duration: 5,
			drawSVG: '100% 100%',
		});
	})
}


$(window).on("load", function() {
	draw()
	ryderenter()

	$("#preload").fadeOut(300)

	gsap.delayedCall(.5, () => {
		ScrollTrigger.refresh();
	});
})